type DriverLike = {
  firstname?: string | null;
  lastname?: string | null;
};

/**
 * Orders drivers by last name, then first name, so a long list stays easy
 * to scan. localeCompare is used so mixed casing and accented names land
 * where a reader expects them.
 */
export const compareDriversByLastName = (
  a: DriverLike,
  b: DriverLike,
): number =>
  (a.lastname || "").localeCompare(b.lastname || "") ||
  (a.firstname || "").localeCompare(b.firstname || "");
